import { render, staticRenderFns } from "./ScreeningStageCard.vue?vue&type=template&id=66c1cb72&"
import script from "./ScreeningStageCard.vue?vue&type=script&lang=js&"
export * from "./ScreeningStageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports